import { defineComponent as _defineComponent } from 'vue'
import EditIcon from '@/components/molecules/EditIcon.vue';
import useFileUpload, { FileUpload } from '@/mixins/useFileUpload';
import {
  computed, Ref, toRefs, watch
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'UploadableItem',
  props: {
  fileName: {
    type: String,
    default: ''
  },
  hint: {
    type: String,
    default: ''
  },
  allowedMimeTypes: {
    type: Array,
    default: () => []
  },
  readOnly: {
    type: Boolean
  },
  contents: {
    type: String,
    default: ''
  },
  label: {
    type: String,
    required: false,
    default: ''
  },
  maxFileSize: {
    type: Number,
    required: false,
    default: 0
  },
  permittedTotalFileSize: { // Maximum allowed size of all files, only works in combination with currentTotalFileSize, max 10GB
    type: Number,
    required: false,
    default: 10000000000
  },
  currentTotalFileSize: { // The current size of all files, only works in combination with permittedTotalFileSize
    type: Number,
    required: false,
    default: 0
  },
  hasUploadError: {
    type: Boolean
  },
  swapColors: Boolean,
  displayErrorBelow: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:contents', 'update:fileName', 'update:fileType'],
  setup(__props, { emit }) {

const props = __props;





const {
  allowedMimeTypes, maxFileSize, permittedTotalFileSize, currentTotalFileSize
} = toRefs(props) as {
  allowedMimeTypes: Ref<string[]>;
  maxFileSize: Ref<number>;
  permittedTotalFileSize: Ref<number>;
  currentTotalFileSize: Ref<number>;
};

const fileUploadConfig = computed<FileUpload>(() => ({
  fileType: {
    allowedMimeTypes: allowedMimeTypes.value
  },
  fileSize: {
    maxFileSizeFromProps: maxFileSize.value,
    permittedTotalFileSizeFromProps: permittedTotalFileSize.value,
    currentTotalFileSizeFromProps: currentTotalFileSize.value
  }
}));

const {
  upload, error: fileError, fileName: uploadFileName, fileContents, mimeType, maxFileSizeMB
} = useFileUpload(fileUploadConfig);

watch(fileContents, (contents) => {
  emit('update:contents', contents);
});
watch(uploadFileName, (uploadFileName) => {
  emit('update:fileName', uploadFileName);
});
watch(mimeType, (mimeType) => {
  emit('update:fileType', mimeType);
});

const error = computed(() => (props.hasUploadError ? 'unknown_error' : fileError.value));


return { __sfc: true,props, emit, allowedMimeTypes, maxFileSize, permittedTotalFileSize, currentTotalFileSize, fileUploadConfig, upload, fileError, uploadFileName, fileContents, mimeType, maxFileSizeMB, error, EditIcon }
}

})